import Vue from 'vue';
import Vuex from 'vuex';
import Criteria from '@muz/jobboard-vue-client/src/store/modules/Criteria';
import Lookup from '@muz/jobboard-vue-client/src/store/modules/Lookup';
import Params from '@muz/jobboard-vue-client/src/store/modules/Params';
import Result from '@muz/jobboard-vue-client/src/store/modules/Result';
import Search from '@muz/jobboard-vue-client/src/store/modules/Search';
import Facet from '@muz/jobboard-vue-client/src/store/modules/Facet';
import TitleAnalysis from './modules/TitleAnalysis';
import JobAd from './modules/JobAd';
import { JobboardBase } from '@muz/jobboard-vue-client/src/store/plugins/JobboardBase';
import config from '../config';
import { BaAnalysis } from './plugins/BaAnalysis';
import ActionDrawer from './modules/ActionDrawer';
import SelectedJobAd from './modules/SelectedJobAd';
import ActionSpeedDial from './modules/ActionSpeedDial';
import Recruitomat from './modules/Recruitomat';
import CompanyStatistics from './modules/CompanyStatistics';
import Requirements from './modules/Requirements';
import ReadabilityAndLengthAnalysis from './modules/ReadabilityAndLengthAnalysis';
import JobAdOptimization from './modules/JobAdOptimization';
import CustomJobAd from '@/store/modules/CustomJobAd';
import Chatbot from '@/store/modules/Chatbot';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        Criteria: Criteria(config.criteria),
        Lookup: Lookup(config.lookup),
        Params: Params(config.params),
        Result: Result(),
        JobAd: JobAd(config),
        Search: Search(config.search),
        Facet: Facet(config.facet),
        SelectedJobAd: SelectedJobAd,
        CustomJobAd: CustomJobAd,
        TitleAnalysis: TitleAnalysis(config.titleAnalysis, config.titleTune),
        CompanyStatistics: CompanyStatistics(config),
        ReadabilityAndLengthAnalysis: ReadabilityAndLengthAnalysis(
            config.readability,
        ),
        Recruitomat: Recruitomat(config.recruitomat),
        Requirements: Requirements(config.requirements),
        ActionDrawer: ActionDrawer,
        ActionSpeedDial: ActionSpeedDial,
        JobAdOptimization: JobAdOptimization(config),
        Chatbot: Chatbot,
    },
    plugins: [JobboardBase, BaAnalysis],
});
